export enum InlineHeightEnum {
  FIXED,
  WINDOW,
  FLUID
}
